// Small building blocks every schema file uses. This file imports no feature file (plan §4, import direction).
import { z } from 'zod'

export const Id = z.string().min(1)

/** A calendar day in India (IST), e.g. 2026-10-24. */
export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'A date like 2026-10-24')
export type IsoDate = z.infer<typeof IsoDate>

/** A moment with the IST offset, e.g. 2026-10-24T10:00:00+05:30. */
export const IsoDateTime = z
  .string()
  .describe('ISO 8601 date-time with the IST offset, e.g. 2026-10-24T10:00:00+05:30')
export type IsoDateTime = z.infer<typeof IsoDateTime>

export const Channel = z.enum(['whatsapp', 'ivr', 'sms'])
export type Channel = z.infer<typeof Channel>

/** A suppression row can block one channel or all of them. */
export const ChannelOrAll = z.enum(['all', 'whatsapp', 'ivr', 'sms'])
export type ChannelOrAll = z.infer<typeof ChannelOrAll>

/**
 * The person's code from the lead registry (Crockford base32, as the demo: no I, L, O, U). Lower case is accepted
 * and turned into upper case, because people type codes by hand.
 */
export const LeadCode = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^FF-[0-9A-HJKMNP-TV-Z]{9}$/, 'A lead code looks like FF-7K2M9QX4T')
export type LeadCode = z.infer<typeof LeadCode>

/** Only the first 2 and last 2 digits, e.g. 98xxxxxx07. The portal never holds a full mobile. */
export const MaskedMobile = z.string().regex(/^\d{2}x{6}\d{2}$/)
export type MaskedMobile = z.infer<typeof MaskedMobile>

/** An answer to "do it" calls that change a count, e.g. "Fetch now" added 3 leads. */
export const CountAnswer = z.object({ count: z.number().int().min(0) })
export type CountAnswer = z.infer<typeof CountAnswer>
